"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainNavigatorContext = void 0;
const react_1 = require("react");
exports.MainNavigatorContext = react_1.createContext({
    navigator: { routes: [] },
    rawNavigator: { routes: [] },
});
